const Utils = {}
Utils.getScript = function (url, op) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true // for firefox3.6
  if (!op) { op = {} } else if (op instanceof Function) { op = { callback: op } }
  if (op.charset) { s.charset = op.charset }
  if (op.crossOrigin) {
    s.crossOrigin = true
  }
  s.src = url
  const h = document.getElementsByTagName('head')[0]
  let done = false
  s.onload = s.onreadystatechange = function () {
    if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
      done = true
      // 防止ie内存泄漏
      s.onload = s.onreadystatechange = null
      if (!op.saveScript) { h.removeChild(s) }
      if (op.callback) { op.callback() }
    }
  }
  h.appendChild(s)
}

Utils.paramToUrl = function (param) {
  let strArr = []
  for (const key in param) {
    strArr.push(`${key}=${param[key]}`)
  }
  return strArr.join('&')
}

Utils.getUrlParam = function (url) {
  url = url ? url : (__isBrowser__ ? location.href : '')
  const reg = /[^\s&?#=\/]+=[^\s&?#=]+/g
  const result = url.match(reg)
  const Obj = {}
  if (result) {
    result.map((item) => {
      const _itemArr = item.split('=')
      if (_itemArr.length > 1) {
        Obj[_itemArr[0]] = decodeURIComponent(_itemArr[1])
      }
    })
  }
  return Obj
}

export default Utils
